import { Box, Flex, Image, Stack, Text } from "@chakra-ui/core";
import React from "react";
import { FooterNav } from "../components/FooterNav";
import { footerNavLInks, navLInks } from "../lib/utils/mock";
import { FaFacebookF, FaLinkedin, FaTwitter, FaYoutube } from "react-icons/fa";
import logoImg from "../assets/images/green-logo.png";
import { Link } from "react-router-dom";
import useAuth from "../context/AuthContext";
import styles from "./Layout.module.css";

import partner1 from "../assets/images/partners/1.png";
import partner2 from "../assets/images/partners/2.png";
import partner3 from "../assets/images/partners/3.png";

import partner4 from "../assets/images/partners/4.jpg";

import partner5 from "../assets/images/partners/5.png";

import partner6 from "../assets/images/partners/6.jpg";

export const Footer = () => {
  const {
    state: { isAuthenticated },
  } = useAuth();

  const isRegisterLink = (link) => {
    if (isAuthenticated && link === "Register") {
      return true;
    } else {
      return false;
    }
  };
  return (
    <Flex
      direction={["column", "column"]}
      bg="RGB(5, 166, 82)"
      className={styles.Footer}
    >
      <Box
        color="#fff"
        padding={["50px 15px", "50px 15px", "50px 35px", "60px 200px"]}
        // borderTop='2px solid #eee'
        d="flex"
        flexDirection={["column"]}
        justifyContent="center"
        className={styles.Container}
      >
        <Flex
          direction={["column-reverse", "column-reverse", "row"]}
          wrap="wrap"
          justify="space-between"
        >
          <Flex
            flexBasis={["100%", "100%"]}
            justify={["space-between", "space-between"]}
            mx={["0", "0"]}
            wrap={["wrap", "wrap", "nowrap"]}
          >
            {footerNavLInks.map((link, index) => {
              return isRegisterLink(link.title) ? null : (
                <FooterNav
                  title={link.title}
                  path={link.path}
                  links={link.dropdownLinks}
                  key={index}
                />
              );
            })}
          </Flex>
        </Flex>
        <Flex
          justify={["start", "start", "space-between"]}
          flexBasis={["100%", "100%"]}
          w={["90%", "90%", "100%"]}
          align={["center", "center"]}
          direction={["column", "column", "row"]}
          mx={["4", "4", "0"]}
          borderTop={["2px solid #eee", "none"]}
          pr="2"
        >
          <Flex
            flexBasis={["100%", "100%", "30%"]}
            w={["70%", "70%", "100%"]}
            justify={["space-between"]}
            align="center"
            mt={["30px", "30px", "60px"]}
            h="100%"
          >
            <Text>Social Media links</Text>
            <a
              href="https://web.facebook.com/SNVGhana"
              target="blank"
              rel="noreferrer"
            >
              <FaFacebookF />
            </a>

            <a
              href="https://twitter.com/snvghana"
              target="blank"
              rel="noreferrer"
            >
              <FaTwitter />
            </a>
            <a
              href="https://www.youtube.com/playlist?list=PL1oZtXroJSPKTsU-
GiBfMACkl4M4phfI8"
              target="blank"
              rel="noreferrer"
            >
              <FaYoutube />
            </a>

            <a
              href="https://www.linkedin.com/company/snv"
              target="blank"
              rel="noreferrer"
            >
              <FaLinkedin />
            </a>
          </Flex>
          <Flex
            align={["center", "center"]}
            flexBasis={["100%", "100%", "80%"]}
            w="100%"
            justify={["center", "center", "flex-end"]}
            direction={["column", "column", "row"]}
            mt={["30px", "30px", "60px"]}
          >
            <Text>Copyright &copy; 2021</Text>
            <Flex align="center" mt={["2", "2", "0"]}>
              <Link to="/disclaimer">
                <Text
                  ml={["0px", "0px", "80px"]}
                  className="hvr-underline-from-left"
                >
                  Disclaimer
                </Text>
              </Link>
              <Link to="/privacy-statement">
                <Text
                  ml={["20px", "20px", "80px"]}
                  className="hvr-underline-from-left"
                >
                  Privacy Statement
                </Text>
              </Link>
            </Flex>
          </Flex>
        </Flex>
      </Box>
      <Box h="100%" bg="#fff">
        <Flex
          padding={["40px 15px", "40px 15px", "40px 120px"]}
          justify="space-between"
          align={["center", "center"]}
          direction={["column", "column", "row"]}
          className={styles.Container}
        >
          <Flex align="center" flexBasis={["15%"]}>
            <Link to="/">
              <Box w="100px">
                <Image
                  src={require("../assets/images/EU-Logo.png")}
                  objectFit="contain"
                />
              </Box>
            </Link>
            <Link to="/">
              <Box w="110px" ml="4">
                <Image
                  src={require("../assets/images/green-logo-2.png")}
                  objectFit="contain"
                />
              </Box>
            </Link>
          </Flex>
          <Stack
            spacing={["2", "2", "8"]}
            isInline
            align="center"
            justify={["center", "center", "flex-end"]}
            flexWrap={["wrap", "wrap", "nowrap"]}
            ml={["2", "2", "0"]}
            flexBasis={["100%", "100%", "85%"]}
            justifySelf={["start", "start", "flex-end"]}
            w="100%"
          >
            <Box>
              <Image
                src={partner1}
                objectFit="cover"
                w={["40px", "65px", "70px"]}
              ></Image>
            </Box>
            <Box p={["0", "0"]} my={["4", "0"]} mx={["4", "0"]}>
              <Image
                src={partner2}
                objectFit="cover"
                w={["40px", "60px"]}
              ></Image>
            </Box>
            <Box p={["0", "0"]}>
              <Image src={partner3} w={["60px", "90px", "120px"]}></Image>
            </Box>
            <Box p={["0", "0"]} my={["4", "4", "0"]} mx={["4", "4", "0"]}>
              <Image
                src={partner4}
                objectFit="cover"
                w={["40px", "70px", "80px"]}
              ></Image>
            </Box>
            <Box p={["0", "0"]}>
              <Image src={partner5} w={["40px", "60px", "80px"]}></Image>
            </Box>
            <Box p={["0", "0"]}>
              <Image src={partner6} w={["40px", "60px", "70px"]}></Image>
            </Box>
          </Stack>
        </Flex>
      </Box>
    </Flex>
  );
};
